export default {
  materialTable: {
    title: 'ボディ別の材料特性',
    body: 'ボディ／体積',
    material: '材料',
    allBodies: 'すべてのボディ',
    thermalTitle: 'ボディ別の熱物性',
    conductivity: 'k (W/(m·K))',
    density: 'ρ (kg/m³)',
    specificHeat: 'cp (J/(kg·K))',
  },
  feaConvergence: {
    stale:
      '1 分以上新しい反復がありません。ソルバーは現在の反復を処理中の可能性があります。',
    title: 'FEA 収束履歴',
    attempt: '解析スコープ',
    attemptScope: 'ステップ {{step}} · 増分 {{increment}} · 試行 {{attempt}}',
    attemptHelp: 'ステップ・増分・試行が解析ループでどう入れ子になるか',
    allIncrements: 'すべての増分',
    iteration: 'ニュートン反復',
    iterationAxis: '反復',
    iterationLabel: '反復 {{n}}',
    // All-increments は各増分の最終ニュートン（ENG-3002）。~100% 温度修正の初回は除く。
    cumulativeIterationAxis: '増分ごとの最終ニュートン',
    cumulativeIterationLabel: '最終ニュートン {{n}}',
    waiting:
      'ニュートン反復を待っています。直接解法では反復が出力されない場合があります。',
    notEmitted:
      'この解析はニュートン反復を出力しませんでした（直接／線形解法）。',
    unavailable: '収束履歴がありません。',
    readError: '収束履歴を更新できません。最後のデータを保持しています。',
    partial:
      '部分履歴：省略 {{omitted}} 行、無効 {{invalid}} 行。完全な記録は元のソルバーファイルをダウンロードしてください。',
    updated: '更新 {{time}}',
    calibration: '予荷重の校正',
    solve: '最終解析',
    contactCount: '接触要素数：{{count}}',
    targetsUnavailable:
      'この解析には収束目標が記録されていません。完了判定はソルバーの判定に従います。',
    targetsDeclared:
      '破線は主要な収束基準を示します。反復が続くと代替残差基準が適用される場合があるため、完了判定はソルバーの判定に従います。',
    met: '達成',
    notMet: '未達成',
    notAvailable: '利用不可',
    residual_force_percent: '力の残差 (%)',
    correction_displacement_percent: '変位修正 (%)',
    residual_flux_percent: '熱流束残差 (%)',
    correction_temperature_percent: '温度修正 (%)',
    omittedNonpositive:
      '対数軸には描けない 0% 以下の値が {{count}} 個あります（2 回目のニュートン反復でちょうど 0 になることはよくあります）。',
    allZeroFinalNewton:
      '{{measures}}：すべての増分の最終ニュートンで 0% のため対数軸には描けません。その残差が動くニュートン経路を見るには、単一の増分を開いてください。',
    allZeroFinalNewtonTip:
      '{{measure}} はこの表示の最終ニュートンすべてで 0% です。ニュートン経路を見るには単一の増分を開いてください。',
    allZeroTip:
      '{{measure}} はこのスコープのニュートンすべてで 0% のため、対数軸には描けません。',
    allZeroMark: 'すべて 0%',
    clippedAbove:
      '軸の上端を超える値が {{count}} 個あり、上端（{{max}}%）に印を付けています。',
    clippedMark: '軸外',
  },
  table: {
    title: '設計点',
    noMatches: '現在のフィルターに一致する設計点はありません。',
  },
  compareGutter: {
    add: '{{short}} を比較に追加',
    remove: '{{short}} を比較から外す',
  },
  columns: {
    // Screen-reader-only names for the two columns whose visible
    // header renders nothing (ENG-1733): the row-action column and
    // the 6px left spacer that offsets the sticky index column.
    actions: '操作',
    spacer: 'スペーサー',
    compare: '比較',
    id: 'ID',
    geometry: 'ジオメトリファイル',
    // 「メッシュファイル」— この設計点で用いたメッシュ資産への参照であり、
    // 「メッシュ化時間」(生成に要した時間) の概念と区別する.
    mesh: 'メッシュファイル',
    // 「メッシュ化時間」— メッシュ生成に要した時間 (meshing duration).
    meshTime: 'メッシュ化時間',
    meshTimeTooltip:
      'この設計点のメッシュを生成するのに要した実時間(ジョブ開始から完了まで)。',
    sim: 'シム',
    status: 'ステータス',
    time: '計算時間',
    timeTooltip:
      'この設計点の解析に要した実時間(ソルバー開始から完了まで)。待機中の行はキュー待ち時間を表示します。ヘッダーを右クリックすると表示形式を切り替えられます。',
  },
  timeMode: {
    menuLabel: '表示形式',
    elapsed: '経過時間',
    elapsedHint: '実時間(既定)',
    completedAbsolute: '完了時刻',
    completedAbsoluteHint: '完了の絶対時刻',
    completedRelative: '完了',
    completedRelativeHint: '現在からの相対時間(例: 5分前)',
    createdAbsolute: '作成時刻',
    createdAbsoluteHint: '投入の絶対時刻',
  },
  columnsMenu: {
    trigger: '列',
    allOn: 'すべて表示',
    allOnTooltip: 'すべての列を表示',
    allOff: 'すべて非表示',
    allOffTooltip: 'すべての結果列を非表示（入力列は残ります）',
    hideNa: 'N/A を非表示',
    hideNaTooltip: 'すべての設計点で値がない列を非表示にします',
  },
  groups: {
    designPoint: '設計点',
    mesh: 'メッシュ',
    inputs: '入力',
    run: '実行',
    results: '結果',
    other: 'その他',
  },
  statusBar: {
    empty: '設計点がありません',
    rendering: '{{total}} 件中 {{from}}–{{to}} 件を表示',
    canonicalOrder: '既定の順序',
    sortedBy: '並べ替え: {{keys}}',
    asc: '昇順',
    desc: '降順',
    reset: '表示をリセット',
  },
  footer: {
    meanConverged: '平均 · 収束 ({{count}})',
  },
  filter: {
    clear: 'フィルターをクリア',
  },
  toolbar: {
    exportCsv: 'CSV をエクスポート',
    searchLabel: '設計点またはシミュレーション ID で検索',
    searchPlaceholder: 'id または sim…',
    density: '行を詰める',
  },
  header: {
    unitHint: '右クリックで単位を変更',
  },
  shortHeaders: {
    force_pressure_x: '圧力 X (N)',
    force_pressure_y: '圧力 Y (N)',
    force_pressure_z: '圧力 Z (N)',
    force_viscous_x: '粘性 X (N)',
    force_viscous_y: '粘性 Y (N)',
    force_viscous_z: '粘性 Z (N)',
    force_normal_mag: '法線 |·| (N)',
    force_tangential_mag: '接線 |·| (N)',
    normal_tangential_ratio: '法線 / 接線 比',
    wall_pressure_min_pa: '壁面 p 最小 (Pa)',
    wall_pressure_max_pa: '壁面 p 最大 (Pa)',
    inlet_flow_rate_m3s: '流入 Q (m³/s)',
    outlet_flow_rate_m3s: '流出 Q (m³/s)',
    inlet_velocity_avg_ms: '流入 U 平均 (m/s)',
    outlet_velocity_avg_ms: '流出 U 平均 (m/s)',
    mass_imbalance_frac: '質量不均衡',
    time_step_count: 'ステップ',
    last_time_step: '最終ステップ',
    execution_time_s: 'ソルバー (s)',
    solution_unphysical: '非物理的',
    divergence_detected: '発散',
  },
  compactHeaders: {
    cm_pitch: 'C_M',
    normal_tangential_ratio: '法線 / 接線 比',
    safety_factor_ultimate: '終局 SF',
    pressure_drop_kinematic: '運動 Δp',
    cd: 'C_D',
    cl: 'C_L',
    force_tangential_mag: '接線力',
    wall_pressure_min_pa: '壁 p 最小',
    wall_pressure_max_pa: '壁 p 最大',
    pressure_drop_pa: 'Δp',
    mass_imbalance_frac: '質量不均衡',
    divergence_detected: '発散',
    solution_unphysical: '非物理',
    converged: '収束',
    iterations: '反復',
    execution_time_s: 'ソルバー (s)',
    force_pressure_x: '圧力 X (N)',
    force_pressure_y: '圧力 Y (N)',
    force_pressure_z: '圧力 Z (N)',
    force_viscous_x: '粘性 X (N)',
    force_viscous_y: '粘性 Y (N)',
    force_viscous_z: '粘性 Z (N)',
    force_normal_mag: '法線力',
    force_x: 'Fx (N)',
    force_y: 'Fy (N)',
    force_z: 'Fz (N)',
    inlet_velocity_avg_ms: '入口 U',
    outlet_velocity_avg_ms: '出口 U',
    inlet_flow_rate_m3s: '入口 Q',
    outlet_flow_rate_m3s: '出口 Q',
    target_temperature_k: '目標 T',
    chip_t_max_k: '熱源固体',
    cop_frac_lref: 'CoP 比',
    cd_band: 'C_D 帯',
    cl_band: 'C_L 帯',
    cd_drift: 'C_D ドリフト',
    cl_drift: 'C_L ドリフト',
    temperature_min: 'T 最小',
    temperature_avg: 'T 平均',
    temperature_max: 'T 最大',
    max_displacement: '最大変位',
    safety_factor_yield: '降伏 SF',
    material_ultimate: '終局',
    col_geometry: '形状',
    col_meshTime: 'メッシュ時間',
  },
  compactHeadersTight: {
    normal_tangential_ratio: 'N/T 比',
    pressure_drop_kinematic: 'Δp 運動',
    wall_pressure_min_pa: 'p 最小',
    wall_pressure_max_pa: 'p 最大',
    force_tangential_mag: '接線',
    force_normal_mag: '法線',
    mass_imbalance_frac: 'M 不均',
    divergence_detected: '発散',
    solution_unphysical: '非物',
    target_temperature_k: '目 T',
    max_displacement: 'Δmax',
    execution_time_s: 'ソル',
    chip_t_max_k: 'T 固',
    col_geometry: '形状',
    col_meshTime: 'M 時',
    col_mesh: 'M',
  },
  inputLabels: {
    nu: '動粘度',
    rho: '密度',
    mu: '粘度',
    fluid: '流体プリセット',
    template: 'テンプレート',
    flowAxis: '流れ軸',
    flowType: '流れの種類',
    turbulenceIntensity: '乱流強度',
    turbulentLengthScale: '乱流長さスケール',
    inletVelocity: '入口速度',
    outletPressure: '出口圧力',
    relaxP: '緩和係数 (圧力)',
    relaxU: '緩和係数 (速度)',
    relaxTurbulence: '緩和係数 (乱流)',
    gradScheme: '勾配スキーム',
    endTime: '終了時間',
    nNonOrthogonalCorrectors: '非直交補正回数',
    writeInterval: '出力間隔',
    residualControlP: '残差目標 (圧力)',
    residualControlU: '残差目標 (速度)',
    referenceArea: '基準面積 (A_ref)',
    referenceChord: '基準弦長 (l_ref)',
  },
  units: {
    heading: '単位',
    rightClickHint: '右クリックで単位を変更',
  },
  cell: {
    true: 'はい',
    false: 'いいえ',
  },
  action: {
    viewInMeshgen: 'MeshGen で表示 →',
    download: 'ダウンロード',
  },
  geometry: {
    openInMeshgen: '{{label}} を MeshGen で開く',
  },
  meshCell: {
    maxSize: '最大要素サイズ：{{size}} mm',
    maxSizeUnset: '最大要素サイズ：未設定',
    cells: '{{value}} 個の 3D セル',
    cellsLoading: 'セル数：読み込み中',
    cellsUnavailable:
      'セル数：取得不可（メッシュ実行中、または件数が出力されていません）',
  },
  // ステータスフィルターのポップオーバー用 DesignPointStatus ラベル
  // (ENG-1744). 以前はワイヤ列挙をアンダースコアだけ空白に置換して
  // そのまま表示していた. チェックボックス一覧に並ぶため短い体言止めで
  // 統一している.
  dpStatus: {
    pending: '保留中',
    preprocessing: '前処理中',
    meshing: 'メッシュ生成中',
    meshReady: 'メッシュ準備完了',
    facesDone: '面の命名完了',
    simulating: 'シミュレーション中',
    extracting: '抽出中',
    pendingReview: 'レビュー待ち',
    completed: '実行終了',
    failed: '失敗',
    cancelled: 'キャンセル済み',
  },
  phaseLabel: {
    failedInMesh: 'メッシュ段階で失敗',
    failedInSim: 'シミュレーション段階で失敗',
    cancelled: 'キャンセル済み',
    done: '完了',
    simulating: 'シミュレーション中',
    meshing: 'メッシュ生成中',
    skipped: 'スキップ済み',
    queued: 'キュー待ち',
    stopped: '停止',
  },
  liveDuration: {
    queued: 'キュー待ち · {{duration}}',
    queuedTooltip:
      'ケースの開始を待機中です。ソルバーが開始すると、タイマーは経過シミュレーション時間に切り替わります。',
  },
  attemptHistory: {
    run: '実行 {{n}} / {{total}}',
    createdAt: '作成 {{time}}',
    submittedAt: 'ソルバーキューに送信 {{time}}',
    submittedUnknown: 'ソルバー送信時刻は不明',
    startedAt: 'ソルバー開始 {{time}}',
    endedAt: '終了 {{time}}',
    queueWait: 'キュー待機 {{duration}}',
    iterations_one: '{{count, number}} 回の反復',
    iterations_other: '{{count, number}} 回の反復',
    iterationsTotal_one: '合計 {{count, number}} 回の反復',
    iterationsTotal_other: '合計 {{count, number}} 回の反復',
    continuedFrom: '{{time}} に停止した実行から続行',
    increments_one: '{{count}} 増分',
    increments_other: '{{count}} 増分',
    cutbacks_one: '{{count}} カットバック',
    cutbacks_other: '{{count}} カットバック',
    aiAutoBadge: 'AI · 自動',
    aiManualBadge: 'AI · 手動',
    succeededFlag: '成功',
    originalRun: '初回実行',
    diagnosisHeading: '診断',
    changesHeading: '変更内容',
    changeReasonPrefix: '理由:',
    sopVersion: 'リトライ規則 v{{v}}',
    copy: 'コピー',
    copied: 'コピーしました',
    copyTooltip:
      '試行ログ全体をプレーンテキストでコピーします。チャットやメッセージにそのまま貼り付けられます。',
    logHeader: '試行ログ · ケース {{id}}',
  },
  decisions: {
    heading_one: '再実行の判断',
    heading_other: '再実行の判断',
    badge_one: '判断 {{count}} 件',
    badge_other: '判断 {{count}} 件',
    reasonPrefix: '理由:',
    verdict: {
      retry: '再実行',
      escalate: '担当者に引き継ぎ',
      decline: '見送り',
    },
    lifecycle: {
      proposed: '提案済み',
      dispatched: '実行済み',
      dismissed: '却下',
      approved: '承認済み',
    },
    confidence: {
      low: '低',
      medium: '中',
      high: '高',
    },
    reason: {
      semanticFailure: 'パラメータ変更では解決できない失敗です',
      advisorDeclined: 'アドバイザーが変更の提案を見送りました',
      lowConfidence: '提案の確信度が基準に達しませんでした',
      advisorInvalid: 'アドバイザーの提案が利用できない形式でした',
      advisorTimeout: 'アドバイザーが時間内に応答しませんでした',
      validationFailed: '提案されたパラメータが検証に失敗しました',
      previouslyTried: '同じ変更をすでに試行済みです',
      capExhausted: '自動再実行の上限に達しました',
      gciIneligible: 'この設計点は自動再実行の対象外です',
      advisorNotEntitled:
        'ワークスペースまたはユーザーに再実行アドバイザーの利用権限がありません',
      engineerRerun: 'エンジニアが設定を変更せずに再実行しました',
    },
  },
  residualChart: {
    title: '残差収束',
    loading: '収束データを読み込み中…',
    notAvailable: 'この実行には残差データがありません。',
    awaitingFirstFlush: 'ソルバーの最初の反復を待機中…',
    notApplicableSolver:
      'このソルバーは残差履歴を出力しません。収束はフィールドごとの残差ではなく、ソルバーログのインクリメント単位で報告されます。',
    noIterationsEmitted: 'このランはソルバーが反復を出力する前に失敗しました。',
    divergedNan: '発散（NaN/Inf）',
    diverging: '発散中',
    iterationAxis: '反復',
    iterationLabel: '反復 {{n}}',
    convergeExitThreshold: '収束終了しきい値',
    convergeExitThresholdTooltip:
      '破線: ソルバーが収束として終了するためにこの方程式が達する必要があった残差目標。目標に達する前に反復／時間上限で停止した実行に表示します。',
    residualTarget: '残差目標',
    residualTargetTooltip:
      '破線: この方程式に与えられた残差目標。実行は目標到達前に発散しました — 各曲線をその破線と見比べてください。',
    convergeExitShort: '収束終了',
    residualTargetShort: '残差目標',
  },
  masterTable: {
    rowOf: '{{total}} 行中 {{current}} 行目',
    rowCount: '{{count}} 行',
    headerHintSort: '{{label}} · クリックで並べ替え',
    headerHintUnits: '{{label}} · クリックで並べ替え · 右クリックで単位を変更',
    simCellTitle: 'シム {{sim}} · 試行 {{attempt}}/{{total}}',
  },
  withDetail: {
    reopenTooltip: '詳細を再表示（Enter）',
  },
  strip: {
    regionLabel: '設計点',
    count_one: '{{count}} 点',
    count_other: '{{count}} 点',
    expandLabel: 'すべての設計点を表示',
    rowLabel: '#{{n}} {{short}} · {{status}}',
    compare: '選択した点を比較…',
  },
  jumpStrip: {
    regionLabel: 'セクションへジャンプ',
    jumpTo: 'ジャンプ:',
    newBadge: '新機能',
    pendingTooltip: 'まだ利用できません — ランの完了待ちです。',
    visualization: '可視化',
    residual: '残差チャート',
    feaConvergence: '収束チャート',
    lineProbe: 'ラインプローブ',
    feaSetup: '設定',
    inputs: '入力',
    results: '結果',
    massInertia: '質量・慣性',
    failureDetail: '失敗詳細',
    attemptHistory: '試行履歴',
    metadata: 'メタデータ',
    verification: '検証',
    sandbox: 'サンドボックス',
    sandboxHandCalc: '手算',
    sandboxConsistency: '一貫性チェック',
    sandboxPlotting: 'プロット群',
  },
  emptyDetail: {
    title: '設計点を選択',
    description:
      '任意の行をクリックすると、入力・結果・残差収束をここに表示します。',
    firstFailure: '最初の失敗',
    bestSoFar: '現在のベスト',
    firstRow: '最初の行',
    kbdStep: '移動',
    kbdClose: '閉じる',
    kbdReopen: '前回を再表示',
  },
  section: {
    resultFieldOnGeometry: '物体表面の流れ場',
    resultTemperatureOnGeometry: '物体表面の温度',
    resultFieldOnModel: 'モデル上の{{field}}',
    resultFeaHeatmap: '応力 / 変位ヒートマップ',
    feaSetup: '設定 — 拘束と荷重',
    feaSetupThermal: '設定 — 熱境界条件',
    residualConvergence: '残差収束',
    lineProbe: '直線上の物理量',
    inputs: '入力',
    results: '結果',
    massInertia: '質量・慣性',
    failureDetail: '失敗の詳細',
    attemptHistory: '試行履歴',
    metadata: 'メタデータ',
    files: 'ファイル',
    sandbox: 'サンドボックス',
  },
  meshInfo: {
    elementType: '要素タイプ',
    strategy: '戦略',
    maxSize: '最大サイズ',
    minSize: '最小サイズ',
    elementOrder: '要素次数',
    cells: 'セル',
    boundaryLayer: '境界層',
    skewnessMax: '歪度（最大）',
    aspectRatioMax: 'アスペクト比（最大）',
    bodySurfaceArea: '物体表面積',
    inletArea: '入口面積',
    outletArea: '出口面積',
    enclosureArea: '外囲面表面積',
    projectedFrontalArea: '投影正面積 ({{axis}})',
    bodyBbox: '物体バウンディングボックス (X × Y × Z)',
    enclosureBbox: '外囲バウンディングボックス (X × Y × Z)',
    bodyVolume: '物体体積',
    enclosureVolume: '外囲体積',
  },
  meshInfoTooltip: {
    bodySurfaceArea:
      '物体壁面の総濡れ面積. 外囲ボックス (外部流) や入口 / 出口面は含まない.',
    inletArea: '入口面の総面積.',
    outletArea: '出口面の総面積.',
    enclosureArea:
      '外囲面の総面積 (外部流) — 物体でも入口・出口でもないすべての面の合計.',
    projectedFrontalArea:
      '流れ方向への物体投影面積:  A_frontal = ½ · Σ A_i · |n_i · a_flow|,  各壁面 i にわたり総和 (A_i = 面面積, n_i = 外向き法線, a_flow = 流れ軸単位ベクトル). ½ は閉曲面を一度だけ数えるため — |n · a| は前面側と背面側の両方を拾う. C_D / C_L の推奨基準面積.',
    bodyBbox:
      '取り込んだ CAD 上で測定した, 物体の軸整列バウンディングボックス (mm).',
    enclosureBbox:
      '外囲の X / Y / Z 寸法 — すべての面重心の最大 / 最小から導出. 軸整列の外囲は厳密に一致.',
    bodyVolume:
      'CAD 物体の体積 (各ソリッドの OCC 体積の合計). ジオメトリ要約に値がない場合 (診断前 / trimesh フォールバック STL) は, 壁パッチ上の発散定理和にフォールバックする.',
    enclosureVolume:
      '外囲の体積, 発散定理 V = ⅓ · Σ (c_i · n_i) · A_i を各外囲面 i について評価 (c_i = 面重心, n_i = 外向き単位法線, A_i = 面面積).',
  },
  meta: {
    simulationId: 'シミュレーション ID',
    meshId: 'メッシュ ID',
    geometryId: '形状',
    designPointLabel: '設計点ラベル',
    meshTags: 'メッシュタグ',
    status: 'ステータス',
    created: '作成',
    started: '開始',
    completed: '完了',
  },
  massProperties: {
    component: 'コンポーネント',
    material: '材料',
    volume: '体積 (m³)',
    mass: '質量 (kg)',
    comX: '重心 x (m)',
    comY: '重心 y (m)',
    comZ: '重心 z (m)',
    ixx: 'Ixx (kg·m²)',
    iyy: 'Iyy (kg·m²)',
    izz: 'Izz (kg·m²)',
    ixy: 'Ixy (kg·m²)',
    ixz: 'Ixz (kg·m²)',
    iyz: 'Iyz (kg·m²)',
    kx: 'kx (m)',
    ky: 'ky (m)',
    kz: 'kz (m)',
  },
  partial: {
    title: '途中経過の結果',
    body: 'この実行は完了前に停止しました。以下の数値は最後に保存されたステップ（ステップ {{step}}）のもので、最終的な答えではなく、検証も行われていません。',
    bodyTime:
      'この実行は完了前に停止しました。以下の数値は最後に保存された時刻（シミュレーション時間 {{step}} 秒）のもので、最終的な答えではなく、検証も行われていません。',
    bodyIncrement:
      'この実行は完了前に停止しました。以下の数値は解けた最後の荷重ステップ（増分 {{step}}）のもので、最終的な答えではなく、検証も行われていません。',
    bodyNothingRecovered:
      'この実行は完了前に停止し、結果を復元できませんでした。以下の失敗の詳細がすべてです。',
    bodyNoStep:
      'この実行は完了前に停止しました。以下の数値は最後に保存されたステップのもので、最終的な答えではなく、検証も行われていません。',
    sourceLatestTime: '流れと温度の場はそのステップのものです。',
    sourceLastIncrement:
      '応力と変位は、解けた範囲までの荷重によるもので、指定した全荷重ではありません。',
    sourceUnknown: '',
  },
  detail: {
    prev: '前の設計点（↑）',
    next: '次の設計点（↓）',
    viewAttempt: '表示する実行',
    viewCurrentAttempt: '最新の試行を表示',
    attemptLoading: 'この試行の保存済み結果を読み込み中…',
    attemptLoadFailed: 'この試行の保存済み結果を読み込めませんでした。',
    historicalHandCalc:
      '手計算は最新の試行にのみ保存されています。確認するには最新の試行を選んでください。',
    indexOf: '{{total}} 件中 #{{current}}',
    runProgressLabel: '計算の進捗',
    runProgressIterations: '反復 {{done}} / {{target}}',
    runProgressSeconds: 't = {{done}} / {{target}} 秒',
    runProgressRunning: '実行中',
    openInMeshgen: 'MeshGen で開く',
    inputCase: '入力ケース',
    inputCaseTooltip:
      '解析前の入力デッキをダウンロードします。ソルバー出力と監視データは試行履歴の結果ダウンロードに含まれます。',
    output: '出力',
    outputTooltip: '出力をダウンロード（結果とソルバーログ）',
    close: '詳細を閉じる（Esc）',
    stopLimit: {
      iterationLimit: '反復上限',
      timeLimit: '時間制限',
    },
    download: 'ダウンロード',
    tagSweep: 'スイープ',
    tagManual: '手動',
    outcomeConverged: '収束',
    outcomeVerified: '検証済み',
    outcomeVerifiedByReviewer: 'レビュー担当者が検証済み',
    outcomeStopped: '停止',
    outcomeGuide: '実行状態の意味',
    outcomeExplanations: {
      verified:
        '自動検証にすべて合格した完了実行、または編集者が残りの検査を認めた実行です（ハンドカルクの関係承認を含む）。ソルバー結果は変わりません。',
      reviewed:
        '編集者が未解決の項目を確認しました。ソルバー結果は変更されません。',
      converged:
        '発散せずに完了しました。検証が未完了の場合は記録された収束状態を確認するか、レビュー検証で残りの制限を認めてください。',
      stopped:
        '時間制限に達して終了しました。チェックポイントがあれば続行できます。',
      diverged: '数値的な失敗により、信頼できる解を得られませんでした。',
      failed:
        '別の理由で使える解が得られずに終了しました。失敗の詳細を確認してください。',
    },
    outcomeCompleted: '完了',
    outcomeDiverged: '発散',
    outcomeFailed: '失敗',
    outcomeTooltip:
      '「検証済み」は計算が完了し該当する検証に合格したこと、または編集者が残りの制限を認めたことを示します。「収束」は発散していない完了実行の暫定表示で、測定上の未収束や反復上限到達も含みます。「発散」は数値的な失敗です。「失敗」は別の理由で解が得られずに終了したことを示します。「停止」は時間制限に達したことを示します。チェックポイントが保存された実行だけを続行できます。',
    fullSolverSetup: '送信されたソルバー設定の全体（初期条件と荷重条件）',
    failedVerification:
      'このランは解が検証される前に失敗しました。記録された残差や最終ステップの値は部分的な診断情報であり、検証に合格した結果ではありません。',
    best: 'ベスト',
    logAxisTooltip:
      'Y 軸は対数スケールです。残差は収束の過程で数桁下がるため（例：1e0 → 1e-6）、線形軸ではゼロ付近で平坦に見えます。対数スケールにより軌跡が読み取りやすくなります。',
    yAxisLog: 'y 軸：対数',
    noSimulationYet:
      'まだシミュレーションがありません — 実行が開始すると収束データが表示されます。',
    parameterCount: '{{count}} 個のパラメータ',
    resultsHint: '行を右クリックで単位を変更',
    massInertiaHint: '重心まわり・グローバル軸',
    componentMassProperties: 'コンポーネント特性（各重心・グローバル軸）',
    componentMassUnavailable:
      'この旧形式ジオメトリにはコンポーネント質量特性がありません。再診断して実行すると、ボディごとの慣性が生成されます。',
    resultsHintWithFrontier:
      'フロンティアのベストとの比較 · 行を右クリックで単位を変更',
    noValues: '表示する値がありません。',
    attemptCount: '{{count}} 回の試行',
    noAttempts: 'まだ試行がありません。',
    filesEmpty:
      'まだシミュレーション試行がありません — シミュレーション実行後にファイルが表示されます。',
    attemptLabel: '試行 {{n}}',
    retryWithAi: 'AIで再試行',
    retryWithAiTooltip:
      'Khoriumのエージェントがこのケースの設定と失敗の詳細を確認し、ソルバー設定を調整して再実行します。',
    retryQueuedToast:
      '再試行を送信しました — エージェントが試行 {{n}} をキューに入れました。',
    retryFailedToast: '再試行を開始できませんでした: {{message}}',
    retryAnyway: 'そのまま再試行',
    retryAnywayTooltip:
      'アドバイザーの変更を加えず、同じ設定でもう一度実行します',
    retryAnywayQueuedToast:
      '再試行を送信しました — 同じ設定で試行 {{n}} をキューに入れました。',
    autoRetryFailedToast: '自動再試行を更新できませんでした: {{message}}',
    continueRun: '実行を続行',
    continueRunTooltip:
      '反復回数または時間の上限を引き上げて、この実行を止まったところから続けます',
    continueQueuedToast: '実行を続行しました — 止まったところから再開します。',
    continueFailedToast: '実行を続行できませんでした: {{message}}',
    continueOutcomeUnknownToast:
      '実行を続行できたか確認できませんでした。現在の状態を表示するため、設計点を再読み込みしています。',
  },
  continueDialog: {
    title: 'この実行を続行',
    iterationLimit:
      'この実行は収まる前に反復回数の上限（反復 {{checkpoint}}）に達しました。続行すると、最初からではなくそこから再開します。',
    timeLimit:
      'この実行は時間切れになりました。続行すると、最初からではなく止まったところから再開します。',
    postprocessTimeLimit:
      'この実行は時間切れになり、その後結果を読み取れませんでした。続行すると、最初からではなく止まったところから再開し、結果を読み直します。',
    postprocessFailed:
      'この実行は完了しましたが、結果を読み取れませんでした。続行すると、最初からではなく最後に保存された地点から再開し、結果を読み直します。',
    reachedIterationLimit:
      'この実行は反復回数の上限（反復 {{checkpoint}}）に達しました。最初からではなくそこから続行するには、反復回数の上限を引き上げてください。',
    convergedAtIterationLimit:
      'この実行は発散せずに反復回数の上限（反復 {{checkpoint}}）に達したため、収束として扱われます。反復回数の上限を引き上げて続行すると、最初からではなくそこから反復を続けます。',
    reachedEndTime:
      'この実行は反復回数の上限（反復 {{checkpoint}}）に達しましたが、結果を読み取れませんでした。最初からではなくそこから続行するには、反復回数の上限を引き上げてください。',
    interrupted:
      'この実行は終わる前に中断されました。設定の問題ではなく、実行していたマシンがなくなったためです。続行すると、最初からではなく最後に保存された地点から再開します。',
    iterations: '新しい反復回数の上限',
    iterationsHint:
      '実行が止まった {{checkpoint}} より大きい値にしてください。',
    cancel: 'キャンセル',
  },
} as const;
